export enum LayoutMode {
  STANDARD = "standard",
  COMPACT = "compact",
  TICKER = "ticker",
  SIDEBAR = "sidebar",
  MESSAGES = "messages",
  MASONRY = "masonry",
  LIST = "list",
}

export enum MediaType {
  TEXT = "text",
  VIDEO = "video",
  PICTURE = "picture",
  GRAPHIC = "graphic",
  TOPIC = "topic",
  AUDIO = "audio",
  STORY = "story",
}

export enum FilterType {
  DATE = "FILTER_DISPLAY_DATE_TIME",
  RELATIVE_DATE = "FILTER_DISPLAY_DATE_TIME_RELATIVE",
  MEDIATYPE = "FILTER_MEDIATYPE",
  FULLTEXT = "FILTER_FULLTEXT",
  QUERY = "FILTER_QUERY_STRING",
  GENRE = "FILTER_GENRE",
  URGENCY = "FILTER_URGENCY",
  CATEGORY = "FILTER_CATEGORY",
  AREA = "FILTER_AREA",
  URN = "FILTER_URN",
  USER_NEED = "FILTER_USERNEED",
  T_SHIRT_SIZE = "FILTER_DPA_T_SHIRT_SIZE",
  STATUS_TAGS = "FILTER_STATUS_TAGS",
  PRODUCT = "FILTER_PRODUCT",
  FILTER_DPA_IQ_PROFILE_ID = "FILTER_DPA_IQ_PROFILE_ID",
}

export enum FilterField {
  HEADLINE = "FIELD_HEADLINE",
  CONTENT = "FIELD_CONTENT",
  KEYWORD = "FIELD_KEYWORD",
  TEASER = "FIELD_TEASER",
}

export enum RelativeDateRange {
  TODAY = "today",
  THIS_MONTH = "this_month",
  THIS_YEAR = "this_year",
  LAST_MONTH = "last_month",
  LAST_YEAR = "last_year",
  LAST_365_DAYS = "last_365_days",
  LAST_30_DAYS = "last_30_days",
}
